import { render, staticRenderFns } from "./KeyTwentyEight.vue?vue&type=template&id=186e714b&scoped=true&"
import script from "./KeyTwentyEight.vue?vue&type=script&lang=js&"
export * from "./KeyTwentyEight.vue?vue&type=script&lang=js&"
import style0 from "./KeyTwentyEight.vue?vue&type=style&index=0&id=186e714b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186e714b",
  null
  
)

export default component.exports